<template>
    <ClientOnly>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 180 181"
            fill="none"
            v-bind="$attrs"
            width="180"
            height="181">
            <g opacity="0.5">
                <g :filter="`url(#filter0_i_1071_15597_${timestamp})`">
                    <path
                        d="M62.1583 124.651C44.8921 124.651 30.2158 118.607 18.1295 106.521C6.04317 94.4347 0 79.7584 0 62.4923C0 59.039 0.258993 55.5858 0.776978 52.1325C1.29496 48.6793 2.2446 45.3987 3.6259 42.2908C4.48921 40.5642 5.56835 39.2692 6.86331 38.4059C8.15827 37.5426 9.58273 36.9383 11.1367 36.593C12.6906 36.2477 14.2878 36.2908 15.9281 36.7225C17.5683 37.1541 19.0791 38.0606 20.4604 39.4419L47.6547 66.6361L66.3022 47.9887L39.1079 20.7944C37.7266 19.4131 36.8201 17.9023 36.3885 16.262C35.9568 14.6218 35.9137 13.0246 36.259 11.4707C36.6043 9.91672 37.2086 8.49226 38.0719 7.19729C38.9352 5.90233 40.2302 4.82319 41.9568 3.95988C45.0648 2.57859 48.3453 1.62895 51.7986 1.11096C55.2518 0.592977 58.705 0.333984 62.1583 0.333984C79.4245 0.333984 94.1007 6.37715 106.187 18.4635C118.273 30.5498 124.317 45.2261 124.317 62.4923C124.317 66.4635 123.971 70.2189 123.281 73.7584C122.59 77.298 121.554 80.7944 120.173 84.2477L172.489 136.046C177.496 141.053 180 147.183 180 154.435C180 161.686 177.496 167.816 172.489 172.823C167.482 177.83 161.353 180.334 154.101 180.334C146.849 180.334 140.719 177.744 135.712 172.564L83.9137 120.507C80.4604 121.888 76.964 122.924 73.4245 123.615C69.8849 124.305 66.1295 124.651 62.1583 124.651Z"
                        :fill="`url(#paint0_linear_1071_15597_${timestamp})`" />
                </g>
                <path
                    d="M47.3011 66.9897L47.6547 67.3432L48.0082 66.9897L66.6557 48.3422L67.0093 47.9887L66.6557 47.6351L39.4615 20.4409C38.1331 19.1125 37.2779 17.6772 36.872 16.1348C36.4593 14.5664 36.4202 13.0502 36.7471 11.5791C37.0793 10.084 37.6597 8.71706 38.488 7.47464C39.2911 6.26999 40.5082 5.2449 42.1703 4.41215C45.233 3.05211 48.4666 2.11635 51.8727 1.60543C55.3017 1.09109 58.7301 0.833984 62.1583 0.833984C79.2934 0.833984 93.842 6.82554 105.833 18.817C117.825 30.8085 123.817 45.3572 123.817 62.4923C123.817 66.4345 123.474 70.1577 122.79 73.6627C122.105 77.1706 121.078 80.6369 119.708 84.062L119.585 84.3697L119.821 84.603L172.136 136.4C172.136 136.4 172.137 136.401 172.137 136.402C177.047 141.312 179.5 147.313 179.5 154.435C179.5 161.557 177.047 167.559 172.136 172.47C167.225 177.381 161.223 179.834 154.101 179.834C146.983 179.834 140.984 177.298 136.072 172.217L136.067 172.212L84.2681 120.154L84.0349 119.92L83.728 120.042C80.3029 121.412 76.8366 122.439 73.3287 123.124C69.8237 123.808 66.1005 124.151 62.1583 124.151C45.0232 124.151 30.4745 118.159 18.4831 106.167C6.49155 94.176 0.5 79.6273 0.5 62.4923C0.5 59.0641 0.757102 55.6357 1.27145 52.2067C1.78236 48.8006 2.71813 45.567 4.07817 42.5043C4.91091 40.8422 5.936 39.6251 7.14066 38.822C8.38308 37.9937 9.75006 37.4133 11.2452 37.0811C12.7162 36.7542 14.2324 36.7933 15.8008 37.206C17.3432 37.6119 18.7785 38.4671 20.1069 39.7955L47.3011 66.9897Z"
                    stroke="white" />
            </g>
            <defs>
                <filter
                    :id="`filter0_i_1071_15597_${timestamp}`"
                    x="0"
                    y="0.333984"
                    filterUnits="userSpaceOnUse"
                    color-interpolation-filters="sRGB"
                    width="180"
                    height="180">
                    <feFlood
                        flood-opacity="0"
                        result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha" />
                    <feOffset />
                    <feGaussianBlur stdDeviation="9" />
                    <feComposite
                        in2="hardAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0" />
                    <feBlend
                        mode="normal"
                        in2="shape"
                        :result="`effect1_innerShadow_1071_15597_${timestamp}`" />
                </filter>
                <linearGradient
                    :id="`paint0_linear_1071_15597_${timestamp}`"
                    x1="90"
                    y1="0.333984"
                    x2="90"
                    y2="180.334"
                    gradientUnits="userSpaceOnUse">
                    <stop stop-color="white" />
                    <stop
                        offset="1"
                        stop-color="white"
                        stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    </ClientOnly>
</template>

<script setup lang="ts">
const timestamp = Date.now() + getRandomNumber(1, 500)
</script>
